import React, { useMemo } from "react";
import { getEventNavigationItems } from "@features/events/navigation";
import { Navigation } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { SettingsFilledIcon } from "@medentic/polaris-icons";
import { EVENT_ROUTES, ROOTS, SETTINGS_ROUTES } from "@app/config/constants";
import { useGetMyCompanies } from "@shared/hooks/common/useGetMyCompanies";
import { HealthcareCompanyType } from "@shared/types/commonTypes";

const EventNavigation: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const params = useParams();
  const selectedEventOrganizerId = params.eventOrganizerId;

  const { companies: eventOrganizers } = useGetMyCompanies({
    type: HealthcareCompanyType.EVENT_ORGANIZER,
    enabled: true,
  });

  const selectedEventOrganizer = useMemo(() => {
    return eventOrganizers?.find(
      (eventOrganizer) => eventOrganizer.id === selectedEventOrganizerId
    );
  }, [eventOrganizers, selectedEventOrganizerId]);

  const userPermissions: string[] | undefined =
    selectedEventOrganizer?.userPermissions?.list;

  const eventNavigationItems = useMemo(() => {
    if (!selectedEventOrganizerId) return [];

    return getEventNavigationItems(
      t,
      selectedEventOrganizerId,
      location.pathname
    );
  }, [t, selectedEventOrganizerId, location.pathname]);

  if (!selectedEventOrganizerId) {
    return null;
  }

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={eventNavigationItems} fill />
      {userPermissions?.includes("update_company") && (
        <Navigation.Section
          items={[
            {
              label: t("clinicNavigation.settings"),
              icon: SettingsFilledIcon,
              url: `${ROOTS.EVENTS}/${selectedEventOrganizerId}/${EVENT_ROUTES.SETTINGS}/${SETTINGS_ROUTES.DETAILS}`,
              selected:
                location.pathname ===
                `${ROOTS.EVENTS}/${selectedEventOrganizerId}/${EVENT_ROUTES.SETTINGS}/${SETTINGS_ROUTES.DETAILS}`,
            },
          ]}
          separator
        />
      )}
    </Navigation>
  );
};

export default EventNavigation;
